import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { Footer } from "../widgets/footer";
import AppRoutes from "./routing/routes/AppRoutes";
import { getCookie } from "react-use-cookie";
import { useSnackbar } from "notistack";
import CookieNotification from "../components/notification/CookieNotification";
import AppMenu from "../widgets/appMenu";
import { MetrikaCounter } from "react-metrika";
import { useVersionCheck } from "../helpers/useVersionCheck";
import { ChatService } from "../APIService/ChatService";
import { initServiceWorker } from "../pages/chat/client";

export let notificationsCapable = false;

function App() {
  const { enqueueSnackbar } = useSnackbar();
  const hasUpdate = useVersionCheck();

  if (navigator.serviceWorker && "PushManager" in window) {
    initServiceWorker()
      .then((res) => {
        console.log("Service worker registered:", res);
        notificationsCapable = ["granted", "prompt"].includes(res);
      })
      .catch((error) => {
        console.error("Failed to register worker:", error);
      });
  } else {
    console.warn("Push-notifications are not supported by this browser");
  }

  useEffect(() => {
    if (hasUpdate) {
      enqueueSnackbar("Доступна новая версия. Перезагрузите страницу.", {
        variant: "info",
        autoHideDuration: 10000,
        anchorOrigin: { horizontal: "left", vertical: "bottom" },
      });
    }
  }, [hasUpdate]);

  useEffect(() => {
    if (
      !getCookie("agreedToUseCookie") &&
      !sessionStorage.getItem("agreedToUseCookie")
    ) {
      enqueueSnackbar(<CookieNotification />, {
        variant: "default",
        autoHideDuration: null,
        hideIconVariant: false,
        preventDuplicate: true,
        style: {
          width: 350,
          height: 175,
          backgroundColor: "white",
          color: "black",
        },
        anchorOrigin: { horizontal: "left", vertical: "bottom" },
      });
    }
  });

  const noYMetrikaIfStartsWith = ["/task/view/", "/lk-for-teacher"];
  return (
    <BrowserRouter
    // future={{
    //   v7_startTransition: true,
    //   v7_relativeSplatPath: true,
    // }}
    >
      <AppMenu />
      <AppRoutes />
      <Footer />
      {window.location.host !== "test.minimath239.ru" &&
      window.location.host !== "localhost:3000" &&
      !noYMetrikaIfStartsWith
        .map((e) => window.location.pathname.startsWith(e))
        .reduce((p, c) => p || c, false) ? (
        <MetrikaCounter
          id={102385331}
          options={{
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true,
            trackHash: true,
          }}
        />
      ) : (
        <></>
      )}
    </BrowserRouter>
  );
}

export default App;
// { !getCookie("agreedToUseCookie") &&
// !sessionStorage.getItem("agreedToUseCookie") ? <CookieNotification/>:<></>}
